import React from "react";
import styled from "styled-components";
import variables from "styles/base/_universal.scss";
import FooterButtons from "components/FooterButtons";
import PrimaryButton from "components/PrimaryButton";
import ImagePlaceHolder from "img/imagePlaceholder.svg";

import TickIcon from "img/Tick.svg";

const ComponentPreview = ({
  title = "IMPORT COMPONENTS",
  imageUrl,
  failedComponents = [],
  setOpenComponentFailedAlertModal,
}) => {
  const primaryButton = (
    <PrimaryButton
      title={"Proceed".toUpperCase()}
      handleClick={() => {
        setOpenComponentFailedAlertModal(false);
      }}
      minWidth={110}
    />
  );

  return (
    <div>
      <Header>
        <TitleText>{title}</TitleText>
        <Label>
          Only successfully imported components will be added to the module.
        </Label>
      </Header>
      <div style={{ backgroundColor: variables.lightBlueColor }}>
        <Body className="customScrollBar">
          <ImportContainer>
            {failedComponents.length > 0 ? (
              failedComponents.map((component, index) => {
                const isSuccess = component.status === "success";

                return (
                  <ImportBox
                    key={index}
                    borderColor={isSuccess ? "#dddfdd" : "#c50f3c"}
                  >
                    <PreviewImage
                      src={component.componentUrl || ImagePlaceHolder}
                      alt="preview"
                      style={{
                        objectFit: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                      }}
                    />
                    <ImportDetails>
                      <article>
                        <LabelText>ID: </LabelText>

                        <SemiBoldText>
                          {component.componentDocNumber}
                        </SemiBoldText>
                      </article>
                      <article>
                        <LabelText>Name: </LabelText>
                        <SemiBoldText>{component.componentName}</SemiBoldText>
                      </article>
                      <ImportStatus color={isSuccess ? "#368a04" : "#c50f3c"}>
                        {isSuccess ? "Importing Completed" : "Importing Failed"}
                        {isSuccess && (
                          <img
                            src={TickIcon}
                            alt="Success"
                            style={{
                              marginLeft: "6px",
                              marginBottom: "3px",
                              verticalAlign: "middle",
                            }}
                          />
                        )}
                      </ImportStatus>
                    </ImportDetails>
                  </ImportBox>
                );
              })
            ) : (
              <NoDataMessage>No components to display.</NoDataMessage>
            )}
          </ImportContainer>
        </Body>
      </div>
      <FooterButtons primaryButton={primaryButton} size="md" />
    </div>
  );
};

const Header = styled.div`
  padding: 0px 20px 16px 20px;
  border-bottom: solid 1px #e6e6ec;
`;

const Body = styled.div`
  height: 324px;
  padding: 12px 20px 0px 20px;
  overflow-y: scroll;
  margin-right: 2px;
  text-align: center;
  background-color: #fff;
`;

const ImportContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const ImportBox = styled.div`
  width: 502px;
  height: 84px;
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 6px;
  border: solid 1px ${(props) => props.borderColor};
  line-height: 1.6;
`;

const PreviewImage = styled.img`
  width: 59px;
  height: 60px;
  margin-right: 16px;
  border-radius: 6px;
  border: solid 1px #dddfdd;
`;

const ImportDetails = styled.div`
  text-align: left;
`;

const ImportStatus = styled.article`
  color: ${(props) => props.color};
  font-weight: bold;
`;

const NoDataMessage = styled.p`
  color: #54565b;
  font-size: 14px;
  font-weight: 600;
`;

const TitleText = styled.span`
  font-size: ${variables.fontSmallV2};
  font-weight: bold;
  color: ${variables.blackColor};
  line-height: 1.6;
`;

const Label = styled.article`
  color: #878888;
  font-size: 12px;
  font-weight: 600;
`;

const LabelText = styled.span`
  font-weight: normal;
  color: #54565b;
`;

const SemiBoldText = styled.span`
  font-weight: 600;
  color: #1e1e1e;
`;

export default ComponentPreview;
